/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2NotificationIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2NotificationIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2NotificationIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#fff"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2NotificationIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-iANWR': alignSelf,'--mt-2-iANWR': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-iANWR': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-iANWR': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-iANWR': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-iANWR': opacity,'--w-10-iANWR': typeof width === 'number' ? `${width}px` : width,'--h-11-iANWR': typeof height === 'number' ? `${height}px` : height,'--f-12-iANWR': fill,'--a-7-iANWR': isAnimated ? animation : "none",'--sd-8-iANWR': isAnimated ? strokeDashoffset : 0,'--sd-9-iANWR': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2NotificationIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.763.313a.75.75 0 01-.172 1.046A5.02 5.02 0 001.5 5.433a.75.75 0 11-1.5 0A6.52 6.52 0 012.716.14a.75.75 0 011.047.172zm.055 2.255A4.5 4.5 0 0111.5 5.75v3.5a1 1 0 001 1 .5.5 0 010 1h-11a.5.5 0 010-1 1 1 0 001-1v-3.5a4.5 4.5 0 011.318-3.182zM5.25 13.25A.75.75 0 016 12.5h2A.75.75 0 018 14H6a.75.75 0 01-.75-.75zM11.284.14a.75.75 0 10-.875 1.22A5.02 5.02 0 0112.5 5.432a.75.75 0 101.5 0A6.52 6.52 0 0011.284.14z"
 style={{'--f-12-iANWR': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}